import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { appConfigFeatureFlagsApi, appConfigFeatureFlagsKeys } from '../api/api';

export function usePublishFeatureFlagDraft() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: appConfigFeatureFlagsApi.publishDraft,
    onSuccess: result => {
      queryClient.setQueryData(appConfigFeatureFlagsKeys.draft(), { draft: null });
      queryClient.invalidateQueries({ queryKey: appConfigFeatureFlagsKeys.all });
      toast.success(
        `Published AppConfig v${result.appConfigVersion} (${result.deploymentState})`,
      );
      if (result.verificationStatus === 'MISMATCH') {
        toast.warning(
          'Post-deploy verification mismatch: the live config does not match what was published. Refresh and inspect before making further changes.',
        );
      } else if (result.verificationStatus === 'FETCH_FAILED') {
        toast.warning(
          'Could not verify the live config after publish. Refresh to confirm your changes took effect.',
        );
      }
    },
    onError: error => {
      const message = error instanceof Error ? error.message : 'Unknown error';
      toast.error(`Publish failed: ${message}`);
    },
  });
}
